import { createStore } from "vuex";
import createPersistedState from 'vuex-persistedstate';
import commonStore from '@/store/modules/commonStore';
import userStore from '@/store/modules/userStore';
import sessionStore from '@/store/modules/sessionStore';
import sendStore from '@/store/modules/sendStore';
import psnStore from "@/store/modules/psnStore";


const store = createStore({
  modules: {
    commonStore,
    userStore,
    sessionStore,
    sendStore,
    psnStore,
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      paths: [
        "sessionStore",
        "psnStore",
      ]
    }),
  ],
});

export { store };